import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setLogin } from "./../_redux/commentSlice";
import { useForm } from "react-hook-form";
import * as actions from "../../Comment/_redux/commentAction";
import ClipLoader from "react-spinners/ClipLoader";
import EmojiMartGroup from "./EmojiMartGroup";
import UserPicture from "./common/UserPicture";
import PopupOption from "./common/PopupOption";
import Editor from './common/Editor';
import { uppercaseFirstLetter } from './../helpers';
import { useTranslation } from 'react-i18next';

function ReplyComment({
    data,
    parentData,
    type,
    setIsShowReply,
    setIsReply,
    lastIndex
}) {

    // Getting curret state of customers list from store (Redux)
    const { currentState } = useSelector(state => ({
        currentState: state.comment
    }));
    const { actionsLoading, commentSetting } = currentState;

    // init dispatch
    const dispatch = useDispatch();

    // người dùng có click hay không
    const [isWrite, setIsWrite] = useState(false);
    // translation
    const { t } = useTranslation();
    // show 3 options(login,register,binh luan k can dang nhap);
    const [showOptions, setShowOptions] = useState(false);

    // effect postmessage and set clientHeight
    useEffect(() => {
        window.parent.postMessage(
            { clientHeight: document.body.offsetHeight },
            "*"
        );
    }, [showOptions, commentSetting, isWrite]);

    const onOpenAndCloseOverlayOptions = (isShowOption, isWrite) => {
        setShowOptions(isShowOption);
        setIsWrite(isWrite);
    };

    const onOpenCommentNotLogin = isWrite => {
        if (commentSetting.isNotLogin == false) {
            dispatch(setLogin(true));
        }
        setIsWrite(isWrite);
    };
    
    // submit data
    const onSubmit = commentData => {
        // onSend({ ...commentData, parentId: data.commentId, answerId: parentComment?.commentId });
        let request = {
            emailOrMobile: commentData.email !== ""
                ? commentData.email
                : commentSetting.userInfo.userId,
            fullName: commentData.fullName !== ""
                ? uppercaseFirstLetter(commentData.fullName.trim().split(/^|\*|@|&|-|'|\(|\)|<|>|#$/g).join("").replace("*",""))
                : commentSetting.userInfo.fullName,
            parentId: parentData.commentId,
            content: commentData.content.trim(),
            answerId:
                type == "replyChilren" ? data.commentId : parentData.commentId,
            categoryId: commentSetting.categoryId,
            objectId: commentSetting.objectId,
            title: commentSetting.title,
            categoryName: commentSetting.categoryName,
            websiteId: commentSetting.websiteId,
            viewUrl: commentSetting.viewUrl
        };
        // has sourceType
        if(commentSetting?.sourceType) request.SourceType = commentSetting?.sourceType;
        dispatch(actions.commentAdd(request));
        setIsWrite(false);
        if (setIsShowReply) {
            setIsShowReply(false);
        } else {
            setIsReply(false);
        }
    };

    return (
        <div className='feedback__box flex gap-[10px] mb-[8px] pr-[10px] py-[5px]  '>
            <div className='w-full rounded-sm '>
                {/* hiển thị box 3 options (login,register,and bình luận k cần đăng nhập) khi click vào button  */}
                {showOptions &&
                    commentSetting.isNotLogin === false &&
                    !commentSetting?.userInfo?.userId && (
                        <PopupOption
                            onOpenCommentNotLogin={onOpenCommentNotLogin}
                            onOpenAndCloseOverlayOptions={
                                onOpenAndCloseOverlayOptions
                            }
                        />
                    )}
                {isWrite == false && (
                    <div>
                        {/* <div className='text-[13px] mb-[5px] text-gray-600 flex '>
                            <span>{t('message.actions.answering')} : </span>
                            <p style={{
                                color:
                                    commentSetting?.version &&
                                    commentSetting?.version === "2.0.0"
                                        ? commentSetting.commentConfiguration
                                              .themeConfig.userBlock.titleColor
                                        : commentSetting?.theme?.textColor
                            }} className='text-[#04416D] ml-[5px] font-notosans-bold'>
                                {type == "replyParent"
                                    ? parentData.userName
                                    : data.userName}
                            </p>
                        </div> */}
                        <button
                            onClick={() =>
                                onOpenAndCloseOverlayOptions(true, true)
                            }
                            className='h-full w-full border rounded-[5px]'>
                            <input
                                className='border-[#CCC] h-[35px] w-full px-[10px] rounded-[5px] focus:outline-none '
                                type='text'
                                placeholder={t('message.input.replyBy',{
                                    fullname: type == "replyParent"
                                    ? parentData.userName
                                    : data.userName
                                })}
                            />
                        </button>
                    </div>
                )}
                {/* khi bình luận mà k cần login show box sau */}
                {commentSetting.isNotLogin &&
                    isWrite &&
                    !commentSetting?.userInfo?.userId && (
                        <div
                            className='relative'>
                            <div className='text-[13px] mb-[5px] text-gray-600 flex '>
                                <span>{t('message.actions.answering')} : </span>
                                <p style={{
                                    color: commentSetting?.version && commentSetting?.version === "2.0.0" && commentSetting.commentConfiguration.themeConfig.userBlock.titleColor
                                }} className='text-[#04416D] ml-[5px] font-notosans-bold'>
                                    {type == "replyParent"
                                        ? parentData.userName
                                        : data.userName}
                                </p>
                            </div>
                            <Editor
                                isLogin={false}
                                onOpenCommentNotLogin={onOpenCommentNotLogin}
                                setIsWrite={setIsWrite} 
                                type='reply'
                                onSubmitReply={onSubmit}
                                lastIndex={lastIndex}
                            />
                        </div>
                    )}
                {/* end box */}

                {/* box user da login */}
                {commentSetting.isNotLogin == false &&
                    isWrite &&
                    commentSetting?.userInfo?.userId && (
                        <div
                            className='relative'>
                            <div className='text-[13px] mb-[5px] text-gray-600 flex '>
                                <span>{t('message.actions.answering')} : </span>
                                <p style={{
                                    color: commentSetting?.version && commentSetting?.version === "2.0.0" && commentSetting.commentConfiguration.themeConfig.userBlock.titleColor
                                }} className='text-[#04416D] ml-[5px] font-notosans-bold'>
                                    {type == "replyParent"
                                        ? parentData.userName
                                        : data.userName}
                                </p>
                            </div>
                            <Editor
                                isLogin={true}
                                onOpenCommentNotLogin={onOpenCommentNotLogin}
                                setIsWrite={setIsWrite} 
                                type='reply'
                                onSubmitReply={onSubmit}
                                lastIndex={lastIndex}
                            />
                        </div>
                    )}
            </div>
        </div>
    );
}

export default ReplyComment;
